import _ from 'lodash'
import KFocused from '../../core/mixins/focused/KFocused'
import KControl from '../../core/mixins/control/KControl'
import KRouterLinkProps from '../../core/utils/KRouterLinkProps'
import Icon from '../icon'
import Ripple from '../ripple'

// const transitionEnd = getCorrectEventName(window, 'transitionend')

// const types = ['primary', 'secondary', 'success', 'warning', 'danger', 'light', 'grey']
const features = ['filled', 'outlined', 'outlinedPlus', 'plain', 'plainPlus', 'text']

export default {
  name: 'KButton',
  mixins: [KFocused, KControl],
  props: {
    // 主题：primary, secondary, success, warning, danger, white, light, lighter, grey, dark, highlight
    type: {
      type: String,
      default: '',
    },
    // 尺寸：huge, large, normal, small, mini
    size: {
      type: String,
      default: '',
    },
    // 左侧图标
    icon: {
      type: String,
      default: '',
    },
    // 禁用状态
    disabled: Boolean,
    // 加载中状态
    loading: Boolean,
    // 按钮点击链接，非空时按钮将渲染成a标签
    href: String,
    // 按钮的默认行为：button / reset / submit
    as: {
      type: String,
      default: 'button',
    },
    // 按钮渲染html标签：默认 button，href有值时为 a，to有值时为 router-link
    tag: {
      type: String,
      default: '',
    },
    // 自定义按钮hover时的风格
    hoverMode: {
      type: [String, Object],
      // `null`
      default() {
        return null
      },
    },
    // 无边框样式
    paddingLess: {
      type: Boolean,
      default: false,
    },
    // width: 100%
    fullWidth: {
      type: Boolean,
      default: false,
    },
    // 去掉波纹动效
    noRipple: {
      type: Boolean,
      default: true,
    },
    // 静态模式：不可点击，无禁用手势
    static: Boolean,
    // 文本模式
    text: Boolean,
    // 线框样式
    outlined: Boolean,
    // 线框plus样式
    outlinedPlus: Boolean,
    // 朴素按钮
    plain: Boolean,
    // 朴素plus按钮
    plainPlus: Boolean,
    // 没有最小宽度
    narrow: Boolean,
    // 渐变按钮 @todo
    gradient: Boolean,
    // 加粗
    bold: Boolean,
    // 圆角
    rounded: Boolean,
    // 圆形
    circle: Boolean,
    // 方形
    square: Boolean,
    // 浮起
    raised: Boolean,
    // 下划线
    underline: Boolean,
    // 虚线边框
    dashed: Boolean,
    // 点线边框,
    dotted: Boolean,
    // 路由使用
    to: null,
  },
  data() {
    return {
      hovered: false,
    }
  },
  computed: {
    hoverType() {
      if (_.isObject(this.hoverMode)) {
        return this.hoverMode.type
      }
      return this.hoverMode
    },
    hoverFeature() {
      if (_.isObject(this.hoverMode)) {
        return this.hoverMode.feature
      }
      return null
    },
    hoverIcon() {
      if (_.isObject(this.hoverMode)) {
        return this.hoverMode.icon
      }
      return null
    },
    hoverExtra() {
      if (_.isObject(this.hoverMode)) {
        const mode = _.clone(this.hoverMode)
        delete mode.type
        delete mode.features
        delete mode.icon
        return mode
      }
    },
  },
  watch: {
    disabled(value) {
      if (value) {
        this.hovered = false
      }
    },
  },
  methods: {
    // emulateForceClick(duration = 350) {
    // clearTimeout(this.emulateTimer)
    // const $button = $(this.$el)
    // $button.removeClass('is-active is-hovered is-focused')
    //
    // this.$nextTick(() => {
    //   $button.addClass('is-hovered is-active')
    //   this.emulateTimer = setTimeout(() => {
    //     $button
    //       .removeClass('is-active is-hovered')
    //       .addClass('is-focused')
    //       .one(`${transitionEnd}.focused`, () => {
    //         $button.removeClass('is-focused')
    //       })
    //   }, duration)
    // })
    renderIcon() {
      let icon = this.icon
      if (this.hovered) {
        icon = this.hoverIcon || icon
      }

      if (!icon) {
        return
      }

      const css = {
        'km-button__icon': true,
      }
      if (this.$slots.default) {
        css['is-mr-4'] = true
      }

      return (
        <Icon
          class={css}
          name={icon}
        ></Icon>
      )
    },
  },
  render() {
    // const filled = !_.some(features, feature => this[feature])

    const css = {
      'km-button': true,
      'km-control': true,
      // [`km-button--${this.type}`]: true,
      'km-ripple-off': !this.kRipple,
      'km-button--focused': this.kHasFocus,
      // feature begin:
      // 'km-button--filled': filled,
      // 'km-button--outlined': this.outlined,
      // 'km-button--outlined-plus': this.outlinedPlus,
      // 'km-button--plain': this.plain,
      // 'km-button--plain-plus': this.plainPlus,
      // 'km-button--text': this.text,
      // feature end
    }

    const cssExtra = {
      'km-button--gradient': this.gradient,
      'km-button--rounded': this.rounded,
      'km-button--square': this.circle || this.square,
      'km-button--circle': this.circle,
      'is-underline': this.underline,
      'is-bold': this.bold,
      'is-narrow': this.narrow,
      'is-loading': this.loading,
      'is-disabled': this.disabled,
      'is-static': this.static,
      'is-fullwidth': this.fullWidth,
      'is-paddingless': this.paddingLess,
      'is-dashed': this.dashed,
      'is-dotted': this.dotted,
    }

    if (this.hovered && this.hoverExtra && !_.isEmpty(this.hoverExtra)) {
      const hoverExtra = this.hoverExtra
      _.assign(cssExtra, _.transform({
        'km-button--gradient': hoverExtra.gradient,
        'km-button--rounded': hoverExtra.rounded,
        'km-button--square': hoverExtra.circle || hoverExtra.square,
        'km-button--circle': hoverExtra.circle,
        'is-underline': hoverExtra.underline,
        'is-bold': hoverExtra.bold,
        'is-narrow': hoverExtra.narrow,
        'is-loading': hoverExtra.loading,
        'is-disabled': hoverExtra.disabled,
        'is-static': hoverExtra.static,
        'is-fullwidth': hoverExtra.fullWidth,
        'is-paddingless': hoverExtra.paddingLess,
        'is-dashed': hoverExtra.dashed,
        'is-dotted': hoverExtra.dotted,
      }, (result, value, key) => {
        if (!_.isNil(value)) {
          result[key] = value
        }
        return result
      }, {}))
    }

    // type && feature && others
    const feature = _.find(features, feature => this[feature]) || 'filled'
    let finalFeature = null
    if (this.hovered) {
      finalFeature = _.kebabCase(this.hoverFeature || feature)
      css[`km-button--${this.hoverType || this.type}`] = true
      _.assign(cssExtra)
    } else {
      finalFeature = _.kebabCase(feature)
      css[`km-button--${this.type}`] = true
    }

    css[`km-button--${finalFeature}`] = true
    css['is-raised'] = (finalFeature === 'filled' || this.outlined) && this.raised

    this.size && (css[`is-${this.size}`] = true)

    const attrs = {
      disabled: this.disabled,
      type: !this.href && (this.as || 'button'),
      tabindex: 0,
    }

    if (this.href) {
      attrs.href = this.href
    }

    let tag = 'button'
    if (this.tag) {
      tag = this.tag
    } else if (this.href) {
      tag = 'a'
    } else if (this.$router && this.to) {
      this.$options.props = KRouterLinkProps(this, this.$options.props)
      tag = 'router-link'
    }

    // 代理点击事件
    const clickHandler = this.$listeners.click

    const events = {
      ...this.$listeners,
      click: (e) => {
        if (this.disabled) {
          return
        }
        if (clickHandler) {
          clickHandler(e)
        }
      },
    }

    if (this.hoverMode) {
      _.assign(events, {
        mouseenter: () => {
          if (this.disabled) {
            return
          }
          this.hovered = true
        },
        mouseleave: () => {
          this.hovered = false
        },
      })
    }

    const data = {
      class: _.assign(css, cssExtra),
      attrs,
      on: events,
    }

    return (
      <tag
        {...data}
      >
        <Ripple
          disabled={this.noRipple || this.disabled}
        >
          {this.renderIcon()}
          {this.$slots.default}
        </Ripple>
      </tag>
    )
  },
}
